module.exports = __webpack_public_path__ + "static/media/YF27_0.24d2a233.jpg";